import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout.jsx';
import Home from './pages/Home.jsx';
import About from './pages/About.jsx';
import Subjects from './pages/Subjects.jsx';
import FAQ from './pages/FAQ.jsx';
import Contact from './pages/Contact.jsx';
import Login from './pages/Login.jsx';
import Booking from './pages/Booking.jsx';
import Portal from './pages/Portal.jsx';
import Quiz from './pages/Quiz.jsx';
import Legal from './pages/Legal.jsx';
import NotFound from './pages/NotFound.jsx';
import Blog from './pages/Blog.jsx';
import BlogPost from './pages/BlogPost.jsx';
import BlogCategory from './pages/BlogCategory.jsx';
import BlogAuthor, { BlogAuthors } from './pages/BlogAuthor.jsx';
import WhatsAppFloat from './components/WhatsAppFloat.jsx';
import AnalyticsListener from './components/AnalyticsListener.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsListener />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/unser-ansatz" element={<About />} />
            <Route path="/faecher" element={<Subjects />} />
            <Route path="/preise" element={<Navigate to="/#preise" replace />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/anmelden" element={<Login />} />
            <Route path="/buchen" element={<Booking />} />
            <Route path="/portal" element={<Portal />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/blog" element={<ErrorBoundary><Blog /></ErrorBoundary>} />
            <Route path="/blog/autoren" element={<ErrorBoundary><BlogAuthors /></ErrorBoundary>} />
            <Route path="/blog/autor/:slug" element={<ErrorBoundary><BlogAuthor /></ErrorBoundary>} />
            <Route path="/blog/kategorie/:slug" element={<ErrorBoundary><BlogCategory kind="category" /></ErrorBoundary>} />
            <Route path="/blog/tag/:slug" element={<ErrorBoundary><BlogCategory kind="tag" /></ErrorBoundary>} />
            <Route path="/blog/:slug" element={<ErrorBoundary><BlogPost /></ErrorBoundary>} />
            {['impressum', 'datenschutz', 'agb'].map((s) => <Route key={s} path={`/${s}`} element={<Legal slug={s} />} />)}
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
        <WhatsAppFloat />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
